import React from 'react';
import '../App.css';
import {
    URL_EXTENSION
} from "../utility/config";
import {
    Link
} from "react-router-dom";


function LoginRequest(props) {

    return (
        <div className="order">
            <div className="loginPopUp-box">
                <div className="box">
                    <div>
                        <h2 className="order_title">Kirjaudu sisään jatkaaksesi sivulla!</h2>
                        <Link to={`${URL_EXTENSION}`}>
                                    <button id="gradient_Button" >Kirjaudu sisään</button>
                        </Link>
                    </div>
                </div>
            </div>

        </div>

    );
}

export default LoginRequest;